import { __assign, __rest } from "tslib";
import React from 'react';
import { BButton } from './BButton';
/**
 * **Has to be a child of BForm**
 *
 * This button will automatically submit the form. It accepts all the props that BButton accepts, since it is a specific type of BButton.
 *
 * This button does not have its own props - it uses the props from BButton
 *
 * **Optional Props:**
 * - [BButton props](https://gitlab.com/2020-bootcamp/forms/mui-bueno/-/blob/development/docs/types/BLayoutProps.md)
 *  - Any prop used in BButton
 * - [BLayoutProps](https://gitlab.com/2020-bootcamp/forms/mui-bueno/-/blob/development/docs/types/BLayoutProps.md)
 *  - custom gridding, sizes, and alignment
 *
 * Default values:
 *  - name = 'submit'
 *  - color = 'primary'
 *  - variant = 'contained'
 *
 * **Basic Example:**
 * ```jsx
 * <BSubmit
 *   name="submit"
 *   color='primary'
 *   variant='contained'
 * >Submit
 * </BSubmit>
 * ```
 *
 * Demos:
 *
 * - [Sample Form](http://mui-bueno.pipeline.east1.simoncomputing.com.s3-website-us-east-1.amazonaws.com)
 *
 * API:
 *
 * - [BSubmit API](https://gitlab.com/2020-bootcamp/forms/mui-bueno/-/blob/development/docs/tag-references/button/BSubmit.md)
 */
export var BSubmit = function (_a) {
    var _b = _a.name, name = _b === void 0 ? 'submit' : _b, _c = _a.color, color = _c === void 0 ? 'primary' : _c, _d = _a.variant, variant = _d === void 0 ? 'outlined' : _d, props = __rest(_a, ["name", "color", "variant"]);
    return (React.createElement(BButton, __assign({}, props, { name: name, type: "submit" })));
};
//# sourceMappingURL=BSubmit.js.map